import React from "react";
import { useParams } from "react-router-dom";
import CommissaryLayout from "../../layout/CommissaryLayout";
import { Tabs } from "antd";
import MerchantDetailsSales from "./MerchantDetailsSales";
import MerchantDetailsInventory from "./MerchantDetailsInventory";

const MerchantDetails = () => {
  const { merchant_id, merchant_user_id } = useParams();

  const item = [
    {
      key: "1",
      label: "Merchant Inventory",
      children: (
        <MerchantDetailsInventory
          merchant_id={merchant_id}
          merchant_user_id={merchant_user_id}
        />
      ),
    },
    {
      key: "2",
      label: "Merchant Sales",
      children: (
        <MerchantDetailsSales
          merchant_id={merchant_id}
          merchant_user_id={merchant_user_id}
        />
      ),
    },
  ];

  return (
    <CommissaryLayout>
      <Tabs defaultActiveKey="1" items={item} />
    </CommissaryLayout>
  );
};

export default MerchantDetails;
